<template>
  <base-dialog :visible="visible" show-close @open="open" @closed="closed">
    <template v-slot:header>{{ title }}</template>
    <el-form class="form" ref="form" :model="form" label-width="80px" label-position="left">
      <el-form-item label="人员">
        <user-selector v-model="form.userIds" :disabled="from == 'edit'" multiple></user-selector>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="form.roles" filterable multiple clearable placeholder="请选择">
          <el-option
            v-for="item in roleList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <el-button @click="closed">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import { getCompanyUsers, getDepartmentTree } from "@/api/userCenter/company"
import { getAllProjectRole } from "@/api/project/project"
import UserSelector from "@/components/FormControl/UserSelector"

export default {
  name: "AddMemberDialog",
  props: {
    visible: Boolean,
    from: String,
    user: Object,
    projectId: {
      type: String,
      required: true
    }
  },
  components: {
    BaseDialog,
    UserSelector
  },
  data() {
    return {
      form: {
        userIds: [],
        roles: []
      },
      roleList: []
    }
  },
  computed: {
    title() {
      if (this.from == "edit") return "编辑成员"
      else if (this.from == "create") return "添加成员"
      return ""
    }
  },
  created() {
    getAllProjectRole(this.projectId).then(roleList => (this.roleList = roleList))
  },
  methods: {
    open() {
      if (this.from == "edit" && this.user) {
        this.form = {
          userIds: [this.user.userId],
          roles: this.user.roles
        }
      } else {
        this.form.userIds = []
        this.form.roles = []
      }
    },
    closed() {
      this.$emit("update:visible", false)
    },
    submit() {
      let members = this.form.userIds.map(userId => ({
        userId,
        roles: this.form.roles
      }))
      this.$emit("submit", members)
      this.closed()
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  padding: 22px 14px 8px;
  ::v-deep {
    .el-form-item__content > .el-select {
      width: 100%;
    }
  }
}
</style>
